// export const formatDate = (dateString) => {
//   if (!dateString) return "";
//   const date = new Date(dateString);
//   return date.toLocaleDateString("en-US", {
//     year: "numeric",
//     month: "long",
//     day: "numeric",
//   });
// };
// export const formatDate = (dateString) => {
//   if (!dateString) return "";

//   return new Date(dateString).toLocaleDateString("en-US", {
//     year: "numeric",
//     month: "long",
//     day: "numeric",
//     timeZone: "UTC",
//   });
// };

export const formatDate = (value) => {
  try {
    if (value == null || value === "") return "";

    const s =
      value instanceof Date
        ? value.toISOString()
        : typeof value === "string"
          ? value
          : String(value);

    // Require leading YYYY-MM-DD
    const datePart = s.slice(0, 10);
    if (!/^\d{4}-\d{2}-\d{2}$/.test(datePart)) return "";

    const [y, m, d] = datePart.split("-").map(Number);
    if (
      !Number.isFinite(y) ||
      !Number.isFinite(m) ||
      !Number.isFinite(d) ||
      m < 1 ||
      m > 12 ||
      d < 1 ||
      d > 31
    ) {
      return "";
    }

    const date = new Date(Date.UTC(y, m - 1, d));
    if (Number.isNaN(date.getTime())) return "";

    return date.toLocaleDateString("en-US", {
      year: "numeric",
      month: "long",
      day: "numeric",
      timeZone: "UTC",
    });
  } catch {
    return "";
  }
};
